export const SUBMISSION_ROLE_TYPE = {
  BORROWER: "BORROWER",
  INSPECTOR: "INSPECTOR",
  LENDER: "LENDER",
  OTHER: "OTHER",
  TITLE_COMPANY: "TITLE_COMPANY",
};
